module.exports = __webpack_public_path__ + "static/media/Preview_iOS_BG_Image.92320978.png";